import React from "react";
import PublicInspectionMessage from "./PublicInspectionMessage";

export default function PublicReInspectionNeedsSchedulingMessage({
  reInspectionId,
}: {
  reInspectionId: string | number;
}) {
  return <PublicInspectionMessage title='Your reinspection needs to be scheduled' inspectionId={reInspectionId} />;
}
